import React,{useState,useEffect} from 'react'
import Loading from '../../../../common/Loading'
import { useParams } from 'react-router-dom'
import {toast} from 'react-toastify'
import clinicService from '../../../../../services/clinic.service'
import LinksCard from './LinksCard'
import AddLinksForm from './AddLinksForm'
function Links() {
  const [loading,setLoading] = useState(false)
  const {clinicId} = useParams()
  const [linkArray,setLinkArray] = useState([])
  const [addNew,setAddNew] = useState(false)

  useEffect(()=>{
   getLinks()
  },[])
  const handleAddClick = ()=>{
    setAddNew(!addNew)
  }
  const getLinks = ()=>{
    setLoading(true)
    clinicService.getReputationLinks(clinicId)
    .then((res)=>{
      setLinkArray(res.data)
      setLoading(false)
    })
    .catch((err)=>{
      console.log(err)
      setLoading(false)
    })
  }
  return (
   <>
    <div className="d-flex justify-content-between">
    <h5 className="card-title" style={{ color: "#012970" }}>
          {" "}
          Reputation Links
        </h5>
        <div>
          <button
            className="btn btn-secondary btn-sm mt-2"
            onClick={handleAddClick}
          >
            <i className="bi bi-person-plus bi-sm"></i> Add New
          </button>
        </div>
    </div>
    {addNew ? <AddLinksForm clinicid={clinicId} getLinks={getLinks} />:""}
    {loading ? <Loading/>:<>
      <div className="row">
        {Array.isArray(linkArray) && linkArray.length>0?(
          linkArray.map((linkitem,index)=>(<LinksCard linkitem={linkitem} getLinks={getLinks} key={index}/>))
        ):"No Repulation Links"}
      </div>
    </>}
   </>
  )
}

export default Links